export default {
    initialStudentCount: 3,
};
